function convertKilometersToFeet(num) {
  let eq =
    "Converting " + num + " kilometers to feet: \n" + num + " * 3280.8 = ";
  let rep = num * 3280.8;
  return eq + rep.toFixed(3);
}

function convertKilometersToInches(num) {
  let eq =
    "Converting " +
    num +
    " kilometers to inches: \n" +
    num +
    " * 39370 = ";
  let rep = num * 39370;
  return eq + rep.toFixed(2);
}

function convertKilometersToYards(num) {
  let eq =
    "Converting " +
    num +
    " kilometers to yards: \n" +
    num +
    " * 1093.6 = ";
  let rep = num * 1093.6;
  return eq + rep.toFixed(3);
}

function convertKilometersToMiles(num) {
  let eq =
    "Converting " +
    num +
    " kilometers to miles: \n" +
    num +
    " * 0.62137 = ";
  let rep = num * 0.62137;
  return eq + rep.toFixed(3);
}

function convertKilometersToCM(num) {
  let eq =
    "Converting " +
    num +
    " kilometers to centimeters: \n" +
    num +
    " * 100000 = ";
  let rep = num * 100000;
  return eq + rep.toFixed(2);
}

function convertKilometersToMeters(num) {
  let eq =
    "Converting " +
    num +
    " kilometers to meters: \n" +
    num +
    " * 1000 = ";
  let rep = num  * 1000;
  return eq + rep.toFixed(2);
}

export {
  convertKilometersToFeet,
  convertKilometersToInches,
  convertKilometersToYards,
  convertKilometersToMiles,
  convertKilometersToCM,
  convertKilometersToMeters
};
